import { Component } from '@angular/core';
import { FeedbackPlatformSystemSettingEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'System Settings') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformsystemsetting-form',
    templateUrl: './feedbackplatformsystemsetting.form.component.html'
})
export class FeedbackPlatformSystemSettingFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformSystemSettingEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

